module.exports = __webpack_public_path__ + "img/reisen udongein inaba_sc2.75fea002.png";